export default {
  stringEmpty: function (value) {
    var empty = false
    if (value === null || value === undefined || value === '' || value === 'null') {
      empty = true
    }
    return empty
  },
  validateEmail: function (value) {
    var myreg = new RegExp(/[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/)
    if (!myreg.test(value)) {
      return false
    } else {
      return true
    }
  },
  isTel: function (value) {
    var isPhone = /^([0-9]{3,4}-)?[0-9]{7,8}$/
    var isMob = /^((\+?86)|(\(\+86\)))?1[3-9](\d{9})$/
    if (isMob.test(value) || isPhone.test(value)) {
      return true
    } else {
      return false
    }
  },
  passwordRuleLow: function (password) {
    var validate = true
    if (this.stringEmpty(password)) {
      validate = false
    } else {
      if (password.length < 6 || password.length > 20) {
        validate = false
      }
    }
    return validate
  },
  passwordRule: function (password) {
    const reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,20}$/
    return reg.test(password)
  },
  nameLenght: function (str) {
    let arr = str.split('')
    let len = arr.length
    let count = 0
    for (let i = 0; i < len; i++) {
      var s = escape(arr[i])
      if (s.indexOf('%u') > -1) {
        count = count + 2
      } else {
        count++
      }
    }
    return count <= 14
  },
  isEmojiCharacter: function (substring) {
    for (var i = 0; i < substring.length; i++) {
      var hs = substring.charCodeAt(i)
      if (hs >= 0xd800 && hs <= 0xdbff) {
        if (substring.length > 1) {
          var ls = substring.charCodeAt(i + 1)
          var uc = ((hs - 0xd800) * 0x400) + (ls - 0xdc00) + 0x10000
          if (uc >= 0x10119 && uc <= 0x1f9c0) {
            return true
          }
        }
      } else if (substring.length > 1) {
        var lsi = substring.charCodeAt(i + 1)
        if (lsi == 0x20e3) {
          return true
        } else if (lsi == 0xd83c) {
          return true
        } else if (lsi == 0xfe0f) {
          return true
        } else if (lsi == 0xfe0e) {
          return true
        }
      } else {
        if (hs >= 0x2100 && hs <= 0x27ff) {
          return true
        } else if (hs >= 0x2B05 && hs <= 0x2b07) {
          return true
        } else if (hs >= 0x2934 && hs <= 0x2935) {
          return true
        } else if (hs >= 0x3297 && hs <= 0x3299) {
          return true
        } else if (hs == 0xa9 || hs == 0xae || hs == 0x303d || hs == 0x3030 ||
          hs == 0x2b55 || hs == 0x2b1c || hs == 0x2b1b ||
          hs == 0x2b50) {
          return true
        }
      }
      if (hs == 0x20) {
        return true
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/script/validate.js